document.addEventListener('pixel:product_view', ({ detail }) => {
  try {
    const { product, selected_variant } = detail

    const ecommerce = {
      currency: Shopify.currency.active,
      value: product.price / 100,
      items: [
        {
          item_id: product.id,
          item_name: product.title,
          item_brand: 'SATORISAN',
          item_category: product.type,
          item_variant: selected_variant.title,
          price: product.price / 100,
        },
      ],
    }

    dataLayer.push({
      event: 'view_item',
      ecommerce,
    })
  } catch (error) {
    console.log(error)
  }
})

document.addEventListener('pixel:add_to_cart', ({ detail }) => {
  try {
    const { line_item } = detail

    const ecommerce = {
      currency: Shopify.currency.active,
      value: line_item.discounted_price / 100,
      items: [
        {
          item_id: line_item.product_id,
          item_name: line_item.product_title,
          item_brand: line_item.vendor,
          item_category: line_item.product_type,
          item_variant: line_item.variant_title,
          price: line_item.discounted_price / 100,
          item_quantity: line_item.quantity,
        },
      ],
    }

    dataLayer.push({
      event: 'add_to_cart',
      ecommerce,
    })
  } catch (error) {
    console.log(error)
  }
})
